export default {
  title: 'Produkter',
  buttons: {
    add_product: 'Tilføj produkt',
  },
  modals: {
    delete_product: {
      title: 'Er du sikker',
      description:
        'Alle nuværende abonnementer med dette produkt forbliver aktive, men der kan ikke oprettes flere abonnementer med det. Denne handling kan ikke fortrydes!',
    },
    delete_price: {
      title: 'Er du sikker',
      description:
        'Alle nuværende abonnementer med denne pris forbliver aktive, men der kan ikke oprettes flere abonnementer med den. Denne handling kan ikke fortrydes!',
    },
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_delete_product: 'Produktet kunne ikke slettes',
    product_got_deleted: 'Produktet er slettet',
    failed_to_delete_price: 'Prisen kunne ikke slettes',
    price_got_deleted: 'Prisen er slettet',
  },
};
